import AppState from 'react-app-state';

export default new AppState({
    renderFirstNoteAlert: false
});



// WEBPACK FOOTER //
// ./src/stores/Help.js